import { createTransferInstruction, getAssociatedTokenAddress, TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { PublicKey, Transaction } from "@solana/web3.js";

// Select this based on your token type
// or use: TOKEN_PROGRAM_ID

/**
 * Transfer SPL tokens using Wallet Adapter.
 *
 * @param senderPublicKey The user's wallet address
 * @param recipientPublicKey The destination wallet address
 * @param mintPublicKey The token mint address
 * @param amount The amount to send (in smallest unit, e.g. 1_000_000 for 1 token)
 * @param connection Solana connection
 * @param sendTransaction From useWallet()
 * @returns {Promise<{ txId: string } | { error: string; errorDescription: string }>}
 */
export const transferSplToken = async ({
  senderPublicKey,
  recipientAta,
  mintPublicKey,
  amount,
  connection,
  sendTransaction,
  signTransaction,
}) => {
  //   try {
  const tokenProgramId = TOKEN_PROGRAM_ID;

  const senderAta = await getAssociatedTokenAddress(
    mintPublicKey,
    senderPublicKey,
    false,
    tokenProgramId
  );
  const senderPk = new PublicKey(senderPublicKey);
  const recipientPublicKey = new PublicKey(recipientAta);
  console.log("📌 Sender Public Address:", senderPublicKey.toBase58());
  console.log("📌 Sender Token Account:", senderAta.toBase58());
  console.log("📌 Recipient Token Account:", recipientPublicKey.toBase58());
  // Ensure wallet is connected to the correct network
  if (senderPublicKey && connection.rpcEndpoint.includes("devnet")) {
    console.log("Connected to Devnet");
  } else {
    console.error("Wrong network - switch to Devnet/Mainnet");
  }

  // const recipientAta = await getAssociatedTokenAddress(
  //   mintPublicKey,
  //   recipientAta,
  //   false,
  //   tokenProgramId
  // );
  const transaction = new Transaction().add(
    createTransferInstruction(
      senderAta, // Sender's associated token account
      recipientAta, // Recipient's associated token account
      senderPk, // Sender's public key (authority)
      amount, // Amount to transfer
      [], // Additional signers (none required)
      tokenProgramId // The token program ID
    )
  );
//   transaction.feePayer = senderPk;
//   transaction.recentBlockhash = (await connection.getLatestBlockhash()).blockhash;

    // Manually sign the transaction
    //   const signedTransaction = await signTransaction(transaction);
    //   const txId = await connection.sendRawTransaction(signedTransaction.serialize());

  const txId = await sendTransaction(transaction, connection);

  console.log("🔄 Waiting for confirmation...");
  const latestBlockhash = await connection.getLatestBlockhash();
  await connection.confirmTransaction(
    {
      signature: txId,
      blockhash: latestBlockhash.blockhash,
      lastValidBlockHeight: latestBlockhash.lastValidBlockHeight,
    },
    "finalized"
  );

  // const txId = await sendTransaction(transaction, connection);
  // await connection.confirmTransaction(txId, "finalized");

  return { txId: txId };
  //   } catch (err) {
  //     console.error("❌ Token transfer failed:", err);
  //     return {
  //       error: "Transaction failed",
  //       errorDescription: "Verify you have enough $FLART and that the recipient is ready.",
  //     };
  //   }
};
